module.exports = __webpack_public_path__ + "static/OpenSans-Italic-00927433252b79d465f8ea8f32a9d1b5.woff";